// Shoe.js
import React, { forwardRef, useEffect } from 'react';
import { useGLTF } from '@react-three/drei';
import * as THREE from 'three';
import { useMediaQuery } from 'react-responsive';

const Shoe = forwardRef(({ onModelLoaded, ...props }, ref) => {
  const { scene } = useGLTF('/vincentshoes.glb'); // Ensure the path is correct
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

  useEffect(() => {
    if (scene) {
      console.log('Model loaded and modelRef set:', scene);

      // Apply rotation and scale
      scene.rotation.set(-Math.PI / 2 + 0.15, 0.05, 0.05);
      const scale = isMobile ? 0.12 : 0.20; // Scale based on mobile or desktop

      scene.scale.set(scale, scale, scale);

      // Center the model
      const box = new THREE.Box3().setFromObject(scene);
      const center = new THREE.Vector3();
      box.getCenter(center);
      scene.position.sub(center);

      // Assign scene to the ref (modelRef in App.js)
      if (ref) ref.current = scene;

      // Notify that the model has loaded
      if (onModelLoaded) {
        onModelLoaded();
        console.log('onModelLoaded called');
      }
    }
  }, [scene, ref, onModelLoaded]);

  return <primitive object={scene} {...props} />;
});

export default Shoe;
